import 'babel-polyfill';
import 'react-toolbox/lib/commons.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import EntityList from './components/Entities';
import Login from './components/Login';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { Router, Route, hashHistory } from 'react-router';
import { Provider } from 'react-redux';
import { store } from './store';
import { RefreshToken } from './queries';
import ConfigSettings from './components/ConfigSettings';
import TicketSettings from './components/TicketSettings';
import OrderSettings from './components/OrderSettings';

if (process.env.NODE_ENV !== 'production') {
  React.Perf = require('react-addons-perf');
}

injectTapEventPlugin();

const AppHandler = () => (
  <MuiThemeProvider>
    <Provider store={store}>
      <Router history={hashHistory}>
        <Route path="/" component={App}></Route>
        <Route path="/entities(/:terminalId)(/:screenName)" component={EntityList}></Route>
        <Route path="/login" component={Login}></Route>
        <Route path="/config-settings" component={ConfigSettings}></Route>
        <Route path="/ticket-settings" component={TicketSettings}></Route>
        <Route path="/order-settings" component={OrderSettings}></Route>
      </Router>
    </Provider>
  </MuiThemeProvider>
);

function Render() {
  ReactDOM.render(
    <AppHandler />,
    document.getElementById('app')
  );
}

function hasSavedConnection() {
  return !!(
    localStorage['graphql_base_url'] &&
    localStorage['graphql_base_url'].trim() !== ''
  );
}

function hasSavedUser() {
  return !!(
    localStorage['login_user_name'] &&
    localStorage['login_user_name'].trim() !== ''
  );
}

function goToLoginAndRender() {
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login';
  }
  Render();
}

const hasConnection = hasSavedConnection();
const hasUser = hasSavedUser();
const hasRefreshToken = !!localStorage['refresh_token'];

if (!hasConnection || !hasUser || !hasRefreshToken) {
  goToLoginAndRender();
} else {
  RefreshToken(localStorage['refresh_token'], (response) => {
    if (response && response.access_token) {
      Render();
    } else {
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_token');
      goToLoginAndRender();
    }
  });
}








// WEBPACK FOOTER //
// ./app/index.jsx